import { THEME_SETTINGS_BUFFER_PUBLISHED, THEME_SETTINGS_REVERTED, THEME_SETTINGS_REVISIONS_FETCHED, CLEAR_THEME_SETTINGS_REVISIONS } from '../actions/ActionTypes';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { gate } from 'hub-http/gates';
import Routes from 'ContentUtils/Routes';
const isUngatedForCHIRP = () => Routes.isUngated(gate('ThemesAndModules:ThemeSettingsChirpMigration'));
const initialState = {
  revisions: [],
  hasMoreRevisions: false,
  requestOffset: 0,
  requestStatus: RequestStatusTypes.UNINITIALIZED,
  revertRequestStatus: RequestStatusTypes.UNINITIALIZED,
  totalRevisionCount: 0
};
const revisionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case THEME_SETTINGS_REVERTED:
      return Object.assign({}, state, {
        revertRequestStatus: action.requestStatus
      });
    case THEME_SETTINGS_REVISIONS_FETCHED:
      {
        if (action.requestStatus === RequestStatusTypes.SUCCEEDED) {
          const {
            objects,
            results,
            limit,
            total,
            hasMore,
            offset
          } = action.payload;
          const useCHIRP = isUngatedForCHIRP();

          //CHIRP returns results, old API returns objects
          let revisions = useCHIRP ? results : objects;
          revisions = revisions || [];
          const newRevisions = [...state.revisions, ...revisions];
          return Object.assign({}, state, {
            revisions: newRevisions,
            hasMoreRevisions: useCHIRP ? hasMore : offset + limit < total,
            //@ts-expect-error FIXME- migrate offset type when fully ungated to CHIRP
            requestOffset: useCHIRP ? offset.offset : newRevisions.length - 1,
            requestStatus: RequestStatusTypes.SUCCEEDED,
            totalRevisionCount: total
          });
        }
        return Object.assign({}, state, {
          requestStatus: action.requestStatus
        });
      }
    case THEME_SETTINGS_BUFFER_PUBLISHED:
    case CLEAR_THEME_SETTINGS_REVISIONS:
      return initialState;
    default:
      return state;
  }
};
export default revisionsReducer;